import { Component, ElementRef, EventEmitter, HostListener, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CeButtonComponent, CeIconComponent, CeModalImports } from '@kempower-nx-workspace/shared/kp-design-system';

@Component({
    selector: 'ce-app-product-update-light-box',
    imports: [CommonModule, CeModalImports, CeButtonComponent, CeIconComponent],
    templateUrl: './light-box.component.html',
    styleUrl: './light-box.component.scss'
})
export class LightBoxComponent {
    imageScale = 1;
    dialogRef: HTMLDialogElement | null = null;
    MAX_ZOOM = 1.7;
    MIN_ZOOM = 0.5;

    el = inject(ElementRef);
    dialogIsOpen = false;

    @Input() imageDescription!: string;
    @Input() imageSrc?: string;
    @Input() imageTitle?: string;

    @Input()
    set isOpen(value: boolean) {
        this.dialogIsOpen = value;
        if (this.dialogIsOpen) {
            if (!this.dialogRef) {
                this.dialogRef = this.el.nativeElement.querySelector('#releaseNoteLightBox') as HTMLDialogElement;
            }
            this.imageScale = 1;
            this.dialogRef?.showModal();
            this.emitStateChange();
        }
    }

    @Output() stateChange = new EventEmitter<'open' | 'close'>();

    onMouseWheel(event: WheelEvent): void {
        event.preventDefault();
        if (event.deltaY < 0) {
            this.imageScale = Math.min(this.imageScale + 0.1, this.MAX_ZOOM); // Max zoom 1.7x
        } else {
            this.imageScale = Math.max(this.imageScale - 0.1, this.MIN_ZOOM); // Min zoom 0.5x
        }
    }

    emitStateChange() {
        this.stateChange.emit(this.dialogIsOpen ? 'open' : 'close');
    }

    close() {
        this.dialogRef?.close();
        this.dialogIsOpen = false;
        this.emitStateChange();
    }

    get transformStyle(): string {
        return `scale(${this.imageScale})`;
    }

    @HostListener('document:keydown.escape', ['$event'])
    onEscapeKey() {
        this.close();
    }
}
